export const useAppTrackingTransparency = () => {
  return true; // this feature is only for iOS.
};
